import {
  DeviceControlGroup,
  Investments,
  Invitation,
  LiveDataSummary,
  LiveWeatherData,
  NotificationSetting,
  SiteConsent,
  SiteDetailData,
  SiteUser,
  SwitchFirmwareVersion,
  UserData,
} from 'clipsal-cortex-types/src/api';
import { CellularDetails } from 'clipsal-cortex-types/src/api/api-site-cellular-details';
import { PaginatedResponseV2 } from 'clipsal-cortex-types/src/common/types';
import { formatDate } from 'clipsal-cortex-utils/src/formatting/formatting';

import demoSite from '../stubs/demo-site.json';
import notificationSettings from '../stubs/notification-settings.json';
import liveData from '../stubs/saturn-live-data.json';
import cellular from '../stubs/site-cellular-details.json';
import siteConsents from '../stubs/site-consents.json';
import siteInvestments from '../stubs/site-investments.json';
import siteUsers from '../stubs/site-users.json';
import switchGroups from '../stubs/switch-groups.json';
import user from '../stubs/user.json';
import weather from '../stubs/weather.json';
import { CURRENT_DAY_IN_TIMEZONE, TOTAL_NUM_DAYS } from '../time-series-helpers';

function getDemoSiteToday(): SiteDetailData {
  const numDaysToMoveBack = TOTAL_NUM_DAYS - 1;
  const site = demoSite as unknown as SiteDetailData;

  const date = new Date(CURRENT_DAY_IN_TIMEZONE);
  date.setDate(date.getDate() - numDaysToMoveBack);
  site.monitoring_start = `${formatDate(date)} 00:00:00`;

  return site;
}

export const CORE_ROUTE_MAP = {
  '/v1/user': user as UserData,
  '/v1/sites/1': getDemoSiteToday(),
  '/v1/sites/1/weather': weather as LiveWeatherData,
  '/v1/sites/1/saturn_live_data_summary': liveData as LiveDataSummary,
  '/v1/sites/1/users': siteUsers as PaginatedResponseV2<SiteUser>,
  '/v1/sites/1/invitations': [] as Invitation[],
  '/v1/sites/1/investments': siteInvestments as Investments,
  '/v1/user/notification_settings?related_app=Schneider Home': notificationSettings as NotificationSetting[],
  '/v1/sites/1/groups': switchGroups as PaginatedResponseV2<DeviceControlGroup>,
  '/v1/sites/1/consent': siteConsents as PaginatedResponseV2<SiteConsent>,
  '/v1/sites/1/site_device/2/firmware_version': { firmware_version: '1.0.0' } as SwitchFirmwareVersion,
  '/v1/sites/1/site_device/3/firmware_version': { firmware_version: '1.0.0' } as SwitchFirmwareVersion,
  '/v1/sites/1/site_devices/cellular_modem_details': cellular as { cellular_modem: CellularDetails },
};
